

import React, { ReactNode, useState } from "react";
import {
    Box,
    makeStyles,
    Theme,
    Typography,
    useTheme,
} from "@material-ui/core";
import Dropzone from "react-dropzone";
import { OpenInBrowser } from "@material-ui/icons";
import { DialogContinue } from "@idha/sanitization-components";
import { useTranslation } from "react-i18next";
export interface DropZoneProps {
    contentComponet?: ReactNode;
    onDropFile: (file: File) => void;
    imageConstrant?: {
        width: number;
        height: number;
    };
}

const useDropZoneStyle = makeStyles((theme: Theme) => ({
    wrapper: {
        display: "flex",
        width: "100%",
        backgroundColor: `${theme.palette.background.paper}`,
    },
    container: {
        border: `2px`,
        borderStyle: "dashed",
        minHeight: "140px",
        display: "flex",
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        textAlign: "center",
    },
    dragicon: {
        transform: `rotate(180deg)`,
        fontSize: "28px",
        color: "rgba(0,0,0,0.54)",
    },
    camera: {
        paddingTop: "4px",
        paddingBottom: "4px",
        minHeight: "240px",
    },
}));
const DropZone: React.FC<DropZoneProps> = ({ contentComponet, onDropFile }) => {
    const { palette } = useTheme();
    const [showRejectedDialog, setShowRejectedDialog] = useState(false);
    const { container, wrapper, dragicon, camera } = useDropZoneStyle();
    const { t } = useTranslation(["FileUpload"]);

    return (
        <Box p={2} className={wrapper}>
            <DialogContinue
                content={t("bad_content_dialog.content", {
                    fileformat: "png ou jpeg",
                })}
                state={showRejectedDialog}
                onAgree={() => setShowRejectedDialog(false)}
                title={t("bad_content_dialog.title")}
            />
            {contentComponet ? (
                <Box
                    className={`${container} ${camera}`}
                    color={palette.grey[600]}
                >
                    {contentComponet}
                </Box>
            ) : (
                <Dropzone
                    accept="image/png, image/jpeg"
                    onDropRejected={() =>{
                        setShowRejectedDialog(true)
                    } 
                    }
                    onDropAccepted={(files) => {
                        onDropFile(files[0]);
                    }}
                >
                    {({
                        getRootProps,
                        isDragActive,
                        isDragAccept,
                        getInputProps,
                    }) => {
                        let borderColor = palette.grey[600];
                        if (isDragActive) {
                            borderColor = palette.primary.light;
                        }
                        // Feature de ao arrastar um arquivo para o dropzone ele informa se o tipo é valído ou não. Por algum motivo, isso funciona no storybook mas não no app em si.

                        //   let borderColor;
                        //   let DragMessage;
                        //   console.log(isDragAccept)
                        //   if (!isDragActive) {
                        //     borderColor = palette.grey[600]
                        //     DragMessage = renderDragMessage("initial")
                        //   }
                        //   else{

                        //     if(isDragAccept){
                        //       DragMessage= renderDragMessage("success")
                        //       }else{
                        //         DragMessage= renderDragMessage("error")

                        //     }
                        // }

                        return (
                            <Box
                                color={borderColor}
                                className={container}
                                {...getRootProps()}
                            >
                                <OpenInBrowser
                                    className={dragicon}
                                    fontSize="inherit"
                                />
                                {/* {...DragMessage} */}
                                <Typography
                                    align="center"
                                    color={"initial"}
                                    variant={"body1"}
                                >
                                    {t("dropzone_content")}
                                </Typography>

                                <input {...getInputProps()} />
                            </Box>
                        );
                    }}
                </Dropzone>
            )}
        </Box>
    );
};

export default DropZone;
